//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxAPI from '@/utils/wx_api'

import Service from '@/service'

export default {
    methods: {
        query (type) {
            this.$emit('changeType', type)
        }
    },
    props: {
        title: String,
        sub_title: String,
        question_list: Array,
        need_btn_main_tx: String,
        need_btn_sub_tx: String,
    }
}
